define('app/models/payment',['app/setup'], function(takhfifan) {
  var screenSize = screen.height + ' * ' + screen.width;
  takhfifan.Payment = Backbone.Model.extend({
    initialize: function () {
      if (typeof ga === 'undefined' || _.isNull(ga)) {
        window.ga = [];
      }
    },

    submit: function() {
      var _this = this;

      $.post(
        this.get('updateUrl'), {
          form_key: this.get('formKey'),
          'payment[method]': this.get('method')
        }).done(function(data){
        if (!_.isNull(data)) {

          if (_.isString(data)) {
            try {
              data = JSON.parse(data);
            } catch (err) {
              takhfifan.eventHub.trigger('payment:savingError', [i18n.t('connection_error_saving')]);
              takhfifan.airbrake.notify(data);
              return;
            }
          }
          if (!_.isNull(data.error) && !_.isUndefined(data.error)) {
            takhfifan.eventHub.trigger(
              'payment:savingError',
              [i18n.t('connection_error_saving')]
            );
            takhfifan.airbrake.notify(data);
          }
        }
      }).fail(function(data, textStatus, request){
        if(_.isString(request) && request === "Session Expired"){
          takhfifan.eventHub.trigger(
            'payment:sessionExpire',
            [i18n.t('checkout_session_expire')]
          );
          ga('send', 'event', 'checkout', 'error', 'Gateway selection : SessionExpire', screenSize);
        }else{
          takhfifan.eventHub.trigger(
            'payment:savingError',
            [i18n.t('connection_error_saving')]
          );
          takhfifan.airbrake.notify(data);
          ga('send', 'event','checkout', 'error', 'Gateway selection : connection_error_saving');
        }
      });
    },

    saveOrder: function() {
      var _this = this;

      $.post(
        this.get('orderUrl'), {
          form_key: this.get('formKey'),
          'payment[method]': this.get('method')
        }).done(function(data){
        if (_.isNull(data.error) || data.error == false) {
          if (_.isEmpty(data.redirect) && data.success) {
            takhfifan.eventHub.trigger('payment:success', _this.get('method'));
          } else if (data.redirect) {
            takhfifan.eventHub.trigger('payment:gw-redirect', data.redirect);
          } else {
            takhfifan.eventHub.trigger(
              'payment:savingError', [i18n.t('connection_error')]
            );
            ga('send', 'event', 'checkout', 'error', 'Gateway selection : connection_error_saving');
            takhfifan.airbrake.notify(data);
          }
        } else {
          if (!_.isNull(data.error_messages))
          takhfifan.eventHub.trigger(
            'payment:savingError', [i18n.t('connection_error')]
          );
          ga('send', 'event', 'checkout', 'error', 'Gateway selection :' + data.error_messages);
          takhfifan.airbrake.notify(data);
        }
      }).fail(function(data, textStatus, request){
        if(_.isString(request) && request === "Session Expired"){
          takhfifan.eventHub.trigger(
            'payment:sessionExpire',
            [i18n.t('checkout_session_expire')]
          );
          ga('send', 'event', 'checkout', 'error', 'Gateway selection : SessionExpire', screenSize);
        }else{
          takhfifan.eventHub.trigger(
            'payment:savingError', [i18n.t('connection_error')]
          );
          takhfifan.airbrake.notify(data);
          ga('send', 'event', 'checkout', 'error', 'Gateway selection : connection_error_saving');
        }
      });
    },

    refreshMethods : function(){
      $.post(
        this.get('refreshUrl'), {
          form_key: this.get('formKey')
        }).done(function(data){
          if (!_.isNull(data)) {
            if (_.isString(data)) {
              try {
                data = JSON.parse(data);
              } catch (err) {
                takhfifan.eventHub.trigger('payment:connectionError', [i18n.t('connection_error')]);
                ga('send', 'event', 'checkout', 'error', 'Gateway selection : connection_error_saving');
                takhfifan.airbrake.notify(data);
                return;
              }
            }
            if (!_.isNull(data.error) && !_.isUndefined(data.error)) {
              takhfifan.eventHub.trigger('payment:connectionError', [i18n.t('connection_error')]);
              ga('send', 'event', 'checkout', 'error', 'Gateway selection : connection_error_saving');
              takhfifan.airbrake.notify(data);
            } else {
              takhfifan.eventHub.trigger('payment:updateMethods', data);
            }
          }
        }).fail(function(data){
          takhfifan.eventHub.trigger('payment:connectionError', [i18n.t('connection_error')]);
          ga('send', 'event', 'checkout', 'error', 'Gateway selection : connection_error_saving');
          takhfifan.airbrake.notify(data);
        });
      }

  });

});

